import React, { useEffect, useState } from 'react'
import PageWrapper from '../../layout/PageWrapper/PageWrapper'
import Page from '../../layout/Page/Page'
import Card, { CardBody, CardHeader, CardLabel, CardTitle } from '../bootstrap/Card'
import Input from '../bootstrap/forms/Input'
import Button, { ButtonGroup } from '../bootstrap/Button'
import { useFormik } from 'formik'
import Icon from '../icon/Icon'
import { TableLoader } from '../../services/loader.services'
import NoDataMsg from '../../common/components/NoDataMsg'
import useSortableData from '../../hooks/useSortableData'
import PaginationButtons, { dataPagination } from '../PaginationButtons'
import { toasts } from '../../services/toaste.service'
import { getProductDetails } from '../../services/productService'

const ProductList = () => {

    useEffect(() => {
        getProductList();
        const interval = setInterval(() => {
            getProductList();
        }, 600000); // 10 minutes

        return () => clearInterval(interval);
    }, []);

    const columnVisibileForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            searchInput: '',
            available: false,
        },
        validate: (values) => { },
        //validateOnChange: false,
        onSubmit: () => { },
    });

    const [productDetailsData, setProductDetailsData] = useState<any>([])
    const [noDataMsg, setNoDataMsg] = useState('')

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const { items, requestSort, getClassNamesFor } = useSortableData(productDetailsData);
    const onCurrentPageData = dataPagination(items, currentPage, perPage);

    const [dataStatus, setDataStatus] = useState(false)

    // Filter
    const filteredData: any = onCurrentPageData.filter(
        (i) =>
            i.sno !== null && i.sno.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase()) ||
            i.lotNo !== null && i.lotNo.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase()) ||
            i.countNo !== null && i.countNo.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase()) ||
            i.assignedCount !== null && i.assignedCount.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())
    );

    function getProductList() {
        getProductDetails(0, 0, 0,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.productDetails;
                    if (data != undefined) {
                        setProductDetailsData(data)
                        setDataStatus(true)
                        for (let i = 0; i < data.length; i++) {
                            data[i].sno = i + 1;
                            data[i].isOpen = false;
                        }
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setNoDataMsg(response.data.message)
                    setDataStatus(true)
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function onPrint(i: any) {
        if (i != undefined) {
            let selectedData = i
            window.open(selectedData.pdfPath);
        }
    }

    const [filteredDataToRefresh, setFilteredDataToRefresh] = useState<any>([]);

    function onView(sno: any, isOpen: any) {
        setProductDetailsData((prev: any) =>
            prev.map((item: any) => ({
                ...item,
                isOpen: item.sno === sno ? !isOpen : false
            }))
        )
    }

    return (
        <PageWrapper title={`Product Stock List`}>
            <Page>
                <Card stretch data-tour='list'>
                    <CardHeader borderSize={1}>
                        <CardLabel icon='List' iconColor='info' className="col-lg-7">
                            <CardTitle tag='div' className='h5'>Product Stock List</CardTitle>
                        </CardLabel>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                        <ButtonGroup className="col-lg-3 d-print-none" color='primary'>
                            <Icon className="mt-1" icon='Search' size='2x' color='primary' />
                            <Input id='searchInput' type='search' placeholder='Search...' onChange={columnVisibileForm.handleChange} value={columnVisibileForm.values.searchInput} />
                        </ButtonGroup>
                    </CardHeader>
                    <CardBody>
                        {!dataStatus ?
                            <TableLoader /> :
                            <div className="table-responsive">
                                <table className='table table-modern table-hover small'>
                                    <thead className='table-primary'>
                                        <tr>
                                            <th scope='col' onClick={() => requestSort('sno')} className='cursor-pointer py-3 border-bottom-0 bg-light rounded-start'>
                                                <span className='small text-uppercase fw-bold'>S.no</span>
                                                <Icon size='lg' className={getClassNamesFor('sno')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('lotNo')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Lot No</span>
                                                <Icon size='lg' className={getClassNamesFor('lotNo')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('countNo')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Count No</span>
                                                <Icon size='lg' className={getClassNamesFor('countNo')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('blend')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>S.Color</span>
                                                <Icon size='lg' className={getClassNamesFor('blend')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('productList')} className='cursor-pointer py-3 border-bottom-0 bg-light text-center'>
                                                <span className='small text-uppercase fw-bold'>Stock Count</span>
                                                <Icon size='lg' className={getClassNamesFor('productList')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('assignedCount')} className='cursor-pointer py-3 border-bottom-0 bg-light text-center'>
                                                <span className='small text-uppercase fw-bold'>Assigned Count</span>
                                                <Icon size='lg' className={getClassNamesFor('assignedCount')} icon='FilterList' />
                                            </th>
                                            <th className='py-3 border-bottom-0 bg-light rounded-end text-center'>
                                                <span className='small text-uppercase fw-bold'>View</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    {filteredData != "" ? <>
                                        {filteredData.map((item: any) => (
                                            <tbody key={item.sno} className='border-top-0'>
                                                <tr onClick={() => onView(item.sno, item.isOpen)} className={`${item.isOpen ? 'bg-l10-info' : ''} shadow-hover-sm transition-base cursor-pointer`}>
                                                    <td className='py-3 fw-bold text-muted' style={{ fontSize: '12px' }}>
                                                        <div className='d-flex align-items-center gap-2'>
                                                            {item.sno}
                                                            {(item.duplicateFlag === true || item.duplicateFlag === 1 || item.duplicateFlag === 'true') && (
                                                                <Icon icon='Warning' color='danger' size='lg' title='Duplicate Product' />
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className='py-3'>
                                                        <span className='fw-semibold' style={{ fontSize: '12px' }}>{item?.lotNo}</span>
                                                    </td>
                                                    <td className='py-3'>
                                                        <span className='fw-semibold' style={{ fontSize: '12px' }}>{item?.countNo}</span>
                                                    </td>
                                                    <td className='py-3'>
                                                        <span className='fw-semibold' style={{ fontSize: '12px' }}>{item?.blend}</span>
                                                    </td>
                                                    <td className='py-3 text-center'>
                                                        <span className='badge bg-l10-primary text-primary px-3 py-2 rounded-pill fw-bold' style={{ fontSize: '18px' }}>
                                                            {item?.productList?.length} {item?.productList?.length === 1 ? 'Bag' : 'Bags'}
                                                        </span>
                                                    </td>
                                                    <td className='py-3 text-center'>
                                                        <span className='badge bg-l10-success text-success px-3 py-2 rounded-pill fw-bold' style={{ fontSize: '18px' }}>
                                                            {item?.assignedCount !== null ? item?.assignedCount : 0} {item?.assignedCount === 1 ? 'Bag' : 'Bags'}
                                                        </span>
                                                    </td>
                                                    <td className='text-center py-3' width={'8%'}>
                                                        <Icon size={'2x'} color={item.isOpen ? 'info' : 'dark'} icon={item.isOpen ? 'KeyboardArrowUp' : 'KeyboardArrowDown'} />
                                                    </td>
                                                </tr>
                                                {item.isOpen ?
                                                    <tr className='bg-light'>
                                                        <td colSpan={7} className='p-4'>
                                                            <div className='card shadow-sm border-0 rounded-3'>
                                                                <div className='table-responsive'>
                                                                    <table className='table table-modern table-hover mb-0'>
                                                                        <thead className='table-info'>
                                                                            <tr>
                                                                                <th className='py-3 border-0 rounded-start'><span className='text-uppercase fw-bold'>#</span></th>
                                                                                <th className='py-3 border-0'><span className='text-uppercase fw-bold'>Bag No</span></th>
                                                                                <th className='py-3 border-0'><span className='text-uppercase fw-bold'>Excise No</span></th>
                                                                                <th className='py-3 border-0'><span className='text-uppercase fw-bold'>No Of Cone</span></th>
                                                                                <th className='py-3 border-0'><span className='text-uppercase fw-bold'>Cone Wt</span></th>
                                                                                <th className='py-3 border-0'><span className='text-uppercase fw-bold'>Tare Weight</span></th>
                                                                                <th className='py-3 border-0'><span className='text-uppercase fw-bold'>Bag Weight</span></th>
                                                                                <th className='py-3 border-0'><span className='text-uppercase fw-bold'>Target Weight</span></th>
                                                                                <th className='py-3 border-0'><span className='text-uppercase fw-bold'>Gross Weight</span></th>
                                                                                <th className='py-3 border-0'><span className='text-uppercase fw-bold'>Date</span></th>
                                                                                <th className='py-3 border-0 rounded-end text-center'><span className='text-uppercase fw-bold'>Action</span></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody className='border-top-0'>
                                                                            {item.productList.map((item1: any, index: any) => (
                                                                                <tr key={index} className='transition-base'>
                                                                                    <td className='py-3 text-muted'>{index + 1}</td>
                                                                                    <td className='py-3 fw-semibold'>{item1.bagNo}</td>
                                                                                    <td className='py-3'>{item1.exciseNo}</td>
                                                                                    <td className='py-3'>{item1.noOfCone}</td>
                                                                                    <td className='py-3 text-muted'>{item1.coneWeight ?? '-'}</td>
                                                                                    <td className='py-3 text-muted'>{item1.tareWeight ?? '-'}</td>
                                                                                    <td className='py-3'>
                                                                                        <span className='fw-semibold'>{item1.netWeight ?? '-'}</span>
                                                                                    </td>
                                                                                    <td className='py-3 text-muted'>{item1.targetWeight ?? '-'}</td>
                                                                                    <td className='py-3 text-muted'>{item1.grossWeight ?? '-'}</td>
                                                                                    <td className='py-3 small text-muted'>{item1.productDateForView}</td>
                                                                                    <td className="py-3 text-center d-print-none">
                                                                                        <Button
                                                                                            color='success'
                                                                                            isLight
                                                                                            icon='Download'
                                                                                            className='rounded-pill shadow-sm'
                                                                                            aria-label='Download'
                                                                                            onClick={() => onPrint(item1)}
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr> : null
                                                }
                                            </tbody>
                                        ))}</> : <NoDataMsg columnsCount={10} msg={noDataMsg || 'No data found'} />
                                    }
                                </table>
                            </div>
                        }
                    </CardBody>
                    <PaginationButtons className="d-print-none" data={items} label='items' setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />
                </Card>
            </Page>
        </PageWrapper >
    )
}

export default ProductList